export type ReadonlyUsersEndpoints = {
  readonly GetUser: string,
  readonly GetUsers: string;
  readonly GetUserById: string;
  readonly AddUpdateUser: string;
  readonly DeleteUser: string;
  readonly CheckInactiveUser: string;
  readonly AuthorityDropDown: string;
  readonly SitesDropDown: string;
  readonly UpdatePassword: string;
  readonly GetAllUserUsingSiteId: string;

  readonly AddUpdateWorkOrderTemplates: string;
  readonly DeleteWorkOrderTemplates: string;
  readonly GetWorkOrderTemplates: string;
  readonly GetAllUserNameForTechinician: string;
  readonly sendMailReply: string;
  readonly GetAllUserInfoToExport: string;
  readonly GetAllTechnicianInfoToExport: string;
  readonly getUserById: string; 
  readonly GetUserSiteAuthorities: string;
};

const controller = 'api';

const UsersEndpoints: ReadonlyUsersEndpoints = {
  GetUser: `${controller}/Users/GetUser`,
  GetUsers: `${controller}/Users/GetUsers`,
  GetUserById: `${controller}/Users/GetUserById`,
  AddUpdateUser: `${controller}/Users/AddUpdateUser`,
  DeleteUser: `${controller}/Users/DeleteUser`,
  CheckInactiveUser: `${controller}/Users/CheckActiveUser`,
  AuthorityDropDown: `${controller}/Authority/GetAuthority`,
  SitesDropDown: `${controller}/Sites/GetSiteList`,
  UpdatePassword: `${controller}/Users/ChangePassword`,
  GetAllUserUsingSiteId: `${controller}/Users/GetAllUserUsingSiteId`,
  // In your endpoints config file


  AddUpdateWorkOrderTemplates: `${controller}/Templates/AddUpdateTemplates`,
  DeleteWorkOrderTemplates: `${controller}/Templates/DeleteWorkOrderTemplates`,
  GetWorkOrderTemplates: `${controller}/Templates/GetAllWorkTemplates`,
  GetAllUserNameForTechinician: `${controller}/Contractor/GetAllUserNameForTechinician`,
  sendMailReply: `${controller}/Tasks/SendMailReplay`,
  GetAllUserInfoToExport: `${controller}/Users/GetAllUserUsingSiteId`,
  GetAllTechnicianInfoToExport: `${controller}/TechnicianDasboard/GetAllActiveTechnicianBySiteId`,
  getUserById: `${controller}/Users`,
  GetUserSiteAuthorities: `${controller}/Users/GetUserSiteAuthorities`, // ADD THIS
 
};

export { UsersEndpoints };
